import axios from 'axios';

var http = axios.create({
    // baseURL: '/api/',
    // headers: {
    //     Authorization: 'Bearer {token}'
    // }
});

const API_URL = '/api/'

http.req = function (method, url, params) {
    var data
    if (method == 'post') {
        data = params
        params = null
    }

    return this.request({
        url: API_URL + url,
        method,
        params,
        data
    })
}

var timeoutHandlers = [];

http.interceptors.request.use(function (config) {
    vi.$store.dispatch('startLoading');
    var token = localStorage.getItem('access_token');
    if (token) {
        config.headers = {'X-Token': token};
    }
    return config;
});


http.interceptors.response.use(function (response) {
    // Do something with response data
    vi.$store.dispatch('stopLoading');
    return response.data;
}, function (error) {

    if (error.response) {
        if (error.response.status == 400 || error.response.status == 500) {
            vex.dialog.alert(error.response.data || 'Произошла неизвестная ошибка')
        }
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
    }
    console.log(error.config);

    vi.$store.dispatch('stopLoading');
    // Do something with response error
    return Promise.reject(error);
});

var httpPlugin = {
    install(Vue, options) {
        Vue.prototype.$http = http
    }
}

export { http, httpPlugin };



// WEBPACK FOOTER //
// ./src/lib/http.js